import tinycolor from 'tinycolor2';
const Color = tinycolor;
export class ColorHelper {
  /**
   * Generate color variations
   * @param {string} colorValue
   */
  static getColorVariations(colorValue, customContrast, alpha = 1) {
    const color = Color(colorValue);
    const contrast = customContrast || this.getContrastColor(colorValue);
    return [
      {
        name: 'contrast',
        value: contrast,
      },
      {
        name: 'hover',
        value: Color.mix(color, contrast, 20).setAlpha(alpha).toHex8String(),
      },
      {
        name: 'active',
        value: Color.mix(color, contrast, 30).setAlpha(alpha).toHex8String(),
      },
    ];
  }
  static getSurfaceColorVariations(colorValue) {
    const color = Color(colorValue);
    return [
      {
        name: 'light',
        value: Color.mix(color, '#ffffff', 96).toHexString(),
      },
      {
        name: 'dark',
        value: Color.mix(color, '#ffffff', 92).toHexString(),
      },
    ];
  }
  static getTintOrShadeColor(colorValue) {
    const color = Color(colorValue);
    const contrast = this.getContrastColor(colorValue);
    return Color.mix(color, contrast, 50).toHexString();
  }
  /**
   * Return best contrast color (black or white)
   * @param {string} colorValue
   */
  static getContrastColor(colorValue) {
    if (Color.isReadable(colorValue, 'white', {})) {
      return '#FFFFFF';
    }
    return '#000000';
  }
}
//# sourceMappingURL=color-helpers.js.map